import {
  Component,
  ChangeDetectionStrategy,
  OnDestroy,
} from '@angular/core';

import { SortOption, SortOptionsEnum, SortTypes } from '~shared/modules/application-event/models/sort-option.model';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { ProductsSortedApplicationEvent } from '~shared/modules/application-event/models';
import { select, Store } from '@ngrx/store';
import { getSortOption, SetSort, SortState } from '~app/modules/brand-plp/store';
import { Observable, Subject } from 'rxjs';
import { TooltipPositions } from '~shared/modules/tooltip/models/tooltip-positions.model';
import { takeUntil } from 'rxjs/operators';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { MediaObserver } from '@angular/flex-layout';

@Component({
  selector: 'app-search-sort-toggler',
  templateUrl: './sort-toggler.component.html',
  styleUrls: ['./sort-toggler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SortTogglerComponent implements OnDestroy {
  selectedOption$: Observable<SortOption>;
  sortOptions: SortOption[] = SortTypes.slice();
  bestMatchSortOption = SortOptionsEnum.BEST_MATCH;

  private unsubscribe$ = new Subject();

  //tooltip
  tooltipPosition = TooltipPositions.center;
  bulletBackgroundColor = '#ccd0d6'; // grey-tint-80
  bulletTextColor = '#ffffff'; // white

  constructor(
    private applicationEventService: ApplicationEventService,
    private mediaObserver: MediaObserver,
    private store: Store<SortState>
  ) {
    this.selectedOption$ = this.store.pipe(select(getSortOption));
    this.checkLayout();
    this.initializeSortOptions();
  }

  private checkLayout() {
    this.mediaObserver.asObservable()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        if (!this.mediaObserver.isActive(MEDIA_ALISES.mobile)) {
          this.tooltipPosition = TooltipPositions.left;
        }
      });
  }

  private initializeSortOptions(): void {
    // TODO: removing new arrivals sort option until it can be used in all pages
    this.sortOptions.pop();
  }

  onSortChange(id: number): void {
    const orderOption = this.sortOptions.find(o => o.id === +id);
    this.applyPriceSort(orderOption);
  }

  applyPriceSort(orderOption: SortOption): void {
    this.applicationEventService.publish(new ProductsSortedApplicationEvent(orderOption));
    this.store.dispatch(new SetSort(orderOption.code));
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
